import React from 'react';

import { P } from './Paragraph.styles';
import { ParagraphProps } from './Paragraph.types';

export function Paragraph({
  children,
  variant = 'p1',
  fontWeight = 'regular',
  ...props
}: ParagraphProps) {
  return (
    <P variant={variant} fontWeight={fontWeight} {...props}>
      {children}
    </P>
  );
}
